import { useMemo } from "react";

import { useActiveWallet, useLoanCloseTransaction } from "@bridgesplit/abf-react";
import { CloseLoanTxnParams } from "@bridgesplit/abf-sdk";
import { Result, LOADING_ERROR } from "@bridgesplit/utils";
import { useTransactionSender } from "app/components/transactions";
import { AppButton } from "app/components/common";
import { Text } from "@bridgesplit/ui";

import { ActionProps } from "./types";

export default function CloseLoan(props: ActionProps) {
    const { loanExpanded } = props;
    const { activeWallet } = useActiveWallet();

    const send = useTransactionSender();
    const closeLoan = useLoanCloseTransaction();

    const ctaError = useMemo(() => {
        if (!loanExpanded) return "No loan";
        return undefined;
    }, [loanExpanded]);

    async function submit() {
        if (!loanExpanded || !activeWallet) return Result.errFromMessage(LOADING_ERROR);

        const params: CloseLoanTxnParams = {
            loan: loanExpanded.loan.address
        };
        return await send(closeLoan, params);
    }

    return (
        <>
            <Text color="caption">This action marks the loan as historical, finalizing its current state.</Text>
            <AppButton disabled={!!ctaError} isTransaction color="error" asyncCta={{ onClickWithResult: submit }}>
                {ctaError ?? "Close loan"}
            </AppButton>
        </>
    );
}
